import React from "react";
import CloseSqaure from "../../../assets/images/auth/close-square.png";

const PollInputOption = ({ data, index, handleChange, onDelete, width }) => {
  return (
    <div className="row d-flex align-items-center mb-3">
      <div className="col-md-11 col-12">
        <input
          type="text"
          className="form-control th-auth-home-popup-poll-form-control w-100"
          style={{ border: "1px solid #707070 !important" }}
          placeholder={`Option ${index + 1} `}
          name="option"
          value={data.option}
          onChange={handleChange}
        />
      </div>
      <div
        className="col-md-1 col-12 px-md-0 pt-md-0 pt-1 
                                 d-md-flex justiy-content-md-between"
      >
        {!data.id && index > 0 ? (
          <div>
            <img
              src={CloseSqaure}
              alt=""
              style={{ cursor: "pointer", width: 20 }}
              onClick={onDelete}
            />
            {width < 768 && (
              <span
                style={{
                  marginLeft: 2.5,
                  fontSize: 14.5,
                  fontFamily: "Poppins",
                  color: "#707070",
                }}
              >
                Delete Option
              </span>
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default PollInputOption;
